var featured_events_carousel = ( function( $ ) {

	var $carousel;

	var _init = function() {
		$carousel = $( '.events-carousel' ).find( '.carousel' );

		_setup_carousel();
	};

	var _set_slide_heights = function() {
		var $slides = $carousel.find( '.slide .slide-event-card' ),
			height = 0;

		$slides.each( function( index, item ) {
			if( $( item ).outerHeight() > height ) {
				height = $( item ).outerHeight();
			}
		} );

		$slides.css( 'height', height );
	};

	var _setup_carousel = function() {
		$carousel.slick( {
			mobileFirst:true,//add this one
			infinite : true,
			arrow: false,
			dots: true,
			centerMode: true,
			centerPadding: '45px',
			slidesToShow: 1,
			responsive: [{
				breakpoint: 992,
				settings: {
					arrows: true,
					centerMode: true,
					centerPadding: '0',
					slidesToShow: 3,
				}
			},{
				breakpoint: 768,
				settings: {
					arrow: false,
					dots: true,
					centerMode: true,
					centerPadding: '0',
					slidesToShow: 3,
				}
			},{
				breakpoint: 481,
				settings: {
					arrow: false,
					dots: true,
					centerMode: false,
					centerPadding: '0',
					slidesToShow: 1,
				}
			} ]
		} );

		_set_slide_heights();
	};

	if(  $( '.events-carousel' ).length > 0  ) {
		$( document ).ready( _init );
	}

} ) ( jQuery );

module.exports = featured_events_carousel;